"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _CurrencyFormat = _interopRequireDefault(require("../../../CurrencyFormat"));
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _Link = _interopRequireDefault(require("../common/Link"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _emailUtils = require("../../../../utils/emailUtils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  container: {
    width: '92px',
    height: '73px',
    fontSize: 0,
    textAlign: 'center',
    verticalAlign: 'middle'
  },
  link: {
    display: 'block',
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: '16px',
    color: _userflow["default"].colors.blackLight
  },
  fullPrice: {
    color: _userflow["default"].colors.blackBase,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px'
  },
  pricePerNight: {
    color: _userflow["default"].colors.blackLight,
    fontSize: '12px',
    lineHeight: '16px'
  },
  emptyDate: {
    color: _userflow["default"].colors.greyLight,
    backgroundColor: '#f2f2f2',
    fontSize: '14px',
    lineHeight: '16px'
  },
  thumbUp: {
    paddingLeft: '2px'
  },
  surcharge: {
    fontSize: '9px',
    lineHeight: '10px'
  },
  moonIcon: {
    marginLeft: '1px',
    height: '9px',
    width: '9px'
  }
};
var Icon = function Icon(_ref) {
  var name = _ref.name,
    style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("span", {
    style: style
  }, /*#__PURE__*/_react["default"].createElement("img", {
    width: 9,
    src: (0, _emailUtils.getImage)(name),
    alt: "\u043D\u043E\u0447\u0435\u0439",
    title: "\u043D\u043E\u0447\u0435\u0439"
  }));
};
var CATEGORY = [{
  min: 0,
  max: 10,
  styles: {
    container: {
      backgroundColor: '#CAECD0'
    },
    link: {
      color: _userflow["default"].colors.blackLight
    },
    fullPrice: {
      color: _userflow["default"].colors.blackLight
    },
    pricePerNight: {
      color: _userflow["default"].colors.blackLight
    }
  },
  moonIconName: 'moon.png'
}, {
  min: 10.1,
  max: 20,
  styles: {
    container: {
      backgroundColor: '#DCF0C8'
    },
    link: {
      color: _userflow["default"].colors.blackLight
    }
  }
}, {
  min: 20.1,
  max: 50,
  styles: {
    container: {
      backgroundColor: '#F4F9DF'
    },
    link: {
      color: _userflow["default"].colors.greyLight
    }
  }
}, {
  min: 50.1,
  max: Infinity,
  styles: {
    container: {
      backgroundColor: '#FFFFFF'
    },
    link: {
      color: _userflow["default"].colors.greyLight
    }
  }
}];
var targetOfferCell = {
  styles: {
    container: {
      backgroundColor: '#FCF5A4',
      boxShadow: '0 10px 15px 0 rgba(216, 214, 204, 0.9), 0 1px 2px 0 rgba(210, 208, 197, 0.9)'
    }
  }
};

/**
 * Выбирает нужный цвет, в зависимости от priceCoefficient
 * @param {number} priceCoefficient процент от минимальной цены за ночь
 * @returns {object} Объект с цветом категории
 */
var getCellStyle = function getCellStyle(priceCoefficient, isTargetOffer) {
  var _cell2;
  var cell = null;
  if (isTargetOffer) {
    cell = targetOfferCell;
  } else {
    cell = CATEGORY.find(function (_ref2) {
      var _ref2$min = _ref2.min,
        min = _ref2$min === void 0 ? 0 : _ref2$min,
        _ref2$max = _ref2.max,
        max = _ref2$max === void 0 ? 0 : _ref2$max;
      return min <= priceCoefficient && priceCoefficient <= max;
    }) || null;
  }
  var resultStyles = {};
  Object.keys(styles).forEach(function (key) {
    var _cell;
    resultStyles[key] = _objectSpread(_objectSpread({}, styles[key]), (_cell = cell) === null || _cell === void 0 ? void 0 : _cell.styles[key]);
  });
  return {
    cellStyles: resultStyles,
    moonIconName: (_cell2 = cell) === null || _cell2 === void 0 ? void 0 : _cell2.moonIconName
  };
};
var PriceMatrixCell = function PriceMatrixCell(_ref3) {
  var _ref3$durations = (0, _slicedToArray2["default"])(_ref3.durations, 2),
    _ = _ref3$durations[0],
    prices = _ref3$durations[1],
    isTargetOffer = _ref3.isTargetOffer,
    className = _ref3.className;
  var link = prices.link,
    isBestOffer = prices.best_offer,
    coefficient = prices.price_coefficient,
    fullPrice = prices.full_price,
    pricePerNight = prices.price_per_night;
  if (fullPrice === 0) {
    var containerStyles = _objectSpread(_objectSpread({}, styles.container), styles.emptyDate);
    var linkStyles = _objectSpread(_objectSpread({}, styles.link), styles.emptyDate);
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
      height: 73,
      className: className,
      style: containerStyles
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      style: linkStyles,
      href: link
    }, "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"));
  }
  var _getCellStyle = getCellStyle(coefficient, isTargetOffer),
    cellStyles = _getCellStyle.cellStyles,
    _getCellStyle$moonIco = _getCellStyle.moonIconName,
    moonIconName = _getCellStyle$moonIco === void 0 ? 'moon.png' : _getCellStyle$moonIco;
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    height: 73,
    className: className,
    style: cellStyles.container
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    style: cellStyles.link,
    href: link
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 4
  }), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    style: cellStyles.fullPrice,
    value: fullPrice
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: cellStyles.pricePerNight
  }, /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: pricePerNight
  }), "/"), /*#__PURE__*/_react["default"].createElement(Icon, {
    name: moonIconName,
    style: styles.moonIcon
  }), isBestOffer && /*#__PURE__*/_react["default"].createElement("span", {
    style: styles.thumbUp
  }, /*#__PURE__*/_react["default"].createElement("img", {
    width: 15,
    src: (0, _emailUtils.getImage)('thumbs_up.png'),
    alt: "\u043B\u0443\u0447\u0448\u0430\u044F \u0446\u0435\u043D\u0430",
    title: "\u041B\u0443\u0447\u0448\u0430\u044F \u0446\u0435\u043D\u0430!"
  }))), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 5
  })));
};
var _default = exports["default"] = PriceMatrixCell;